"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultProps = exports.propTypes = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var propTypes = {
  'aria-label': _propTypes.default.string,
  description: _propTypes.default.string,
  dismissable: _propTypes.default.bool,
  icon: _propTypes.default.element,
  intent: _propTypes.default.oneOf(['information', 'success', 'warning', 'danger']),
  title: _propTypes.default.string.isRequired,
  onDismissClick: _propTypes.default.func,
  tooltipText: _propTypes.default.string
};
exports.propTypes = propTypes;
var defaultProps = {
  'aria-label': undefined,
  description: undefined,
  dismissable: false,
  icon: undefined,
  intent: 'information',
  onDismissClick: undefined,
  tooltipText: undefined
};
exports.defaultProps = defaultProps;